export const THIRD_PARTY_SENSOR_LINKED_APPLIANCES_TABLE_FRENCH_LOCALE = {
  globalSearchPlaceholder: "Rechercher une valeur...",
  empty: "Aucun appareil associé trouvé...",
  headers: {
    name: "Nom",
    modulatorCsId: "Modulateur Cs Id",
    modulatorHwId: "Modulateur Hw Id",
  },
  actions: {
    deleteLinkedAppliances: "Supprimer les associations séléctionnées",
  },
};
